<div>
  <ng-container *ngIf="withMainHeadline" class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Vorlagen'" [icon]="'icon-templates'" [iconToolTip]="'Vorlagen'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>

  <ng-container *ngIf="!withMainHeadline">
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
  <ng-template #table>
    <div class="body">
      <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
          Vorlagenliste
        </div>
        <div class="basis-1/2 flex flex-row justify-end items-center">
          <!-- <input pInputText type="text" class="p-inputtext p-component p-element mr-3"
            (input)="dtresources.filterGlobal($event.target?.['value'], 'contains')" placeholder="Ressource suchen" /> -->
        </div>
      </div>
        <div *ngFor="let template of templates">
          <div class="mt-[1.25rem]">
            <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
              <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
                <!-- <i [className]="'icon-templates'"></i> -->
                {{template?.name}} / {{template?.type}}
              </div>
              <div class="basis-1/2 flex flex-row justify-end items-center">
                <app-nx-button (click)="createTemplateVariant(template?.key)" toolTip="neue Vorlage anlegen" icon="icon icon-plus" />
              </div>
            </div>
            <div class="table_header basis-full p-5 flex flex-row items-center" *ngIf="template?.templateVariants && template?.templateVariants?.length > 0">
              <div class="header w-1/4">Name</div>
              <div class="header w-1/4">System</div>
              <div class="header w-1/4">Aktiv</div>
              <div class="header w-1/4"></div>
            </div>
            <div class="table_row pl-5 flex flex-row items-center basis-full" *ngFor="let variant of template?.templateVariants" (click)="viewTemplateVariant(template?.key, variant.id)">
              <div class="value w-1/4">
                {{variant?.name}}
              </div>
              <div class="value w-1/4">
                <p-checkbox [binary]="true" [ngModel]="variant.isSystem" [disabled]="true"></p-checkbox>
              </div>
              <div class="value w-1/4">
                <p-checkbox [binary]="true" [ngModel]="variant.isActive" [disabled]="true"></p-checkbox>
              </div>
              <div class="flex justify-end items-center w-1/4 delete">
                <app-nx-button toolTip="Löschen" icon="icon icon-trash" (click)="$event.stopPropagation();variant?.isDeletable && confirmDialog(variant)" [disabled]="!variant.isDeletable"/>
              </div>
            </div>
            <div *ngIf="templates?.length === 0" class="no-data">
              <p>keine Templates vorhanden</p>
            </div>
          </div>
      </div>
    </div>
  </ng-template>
</div>
